import request from '@/plugin/axios'
import { saveAs } from 'file-saver'

export function page(query) {
return request({
url: '/api/admin/alarm/sysNotifys/pageList',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/alarm/sysNotifys',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/alarm/sysNotifys/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/alarm/sysNotifys/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/alarm/sysNotifys/' + id,
method: 'put',
data: obj
})
}


export function exportNotifyCsv(type,fileName,obj={}) {
    if(!type)return;
    return request({
        url: '/api/admin/alarm/sysNotifys/export/'+type,
        method: 'post',
        params: obj,
        responseType:'blob'
    }).then((res)=>{
        let blob = new Blob([res.data],{type:""});
        saveAs(blob,fileName)
    }).catch(err=>{
        console.log(err);
    })
}